module.exports = __webpack_public_path__ + "brand.png?285dfd44ff78af0dcb062cb50ff3aff0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand.png
// module id = 105
// module chunks = 0